import { render } from "./PokemonOptions.vue?vue&type=template&id=73ddf4e0&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=73ddf4e0&scoped=true&lang=css"

import exportComponent from "/home/trimogesimo/a-subir/Pokemon_Game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ddf4e0"]])

export default __exports__